var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
function Content(props) {
    return (_jsx("div", __assign({ className: "content-adjust", style: { paddingTop: props.isDevEnvironment ? '83px' : '57px', flex: 1 } }, { children: props.children })));
}
export default Content;
